import React from 'react'
import Table from './../Table/Table'

function MemberList() {
  return (
    
    
          <Table></Table>
     
    
  )
}

export default MemberList